import {
  EKwikUIInputCase,
  EKwikUIInputSize,
  EKwikUIInputType
} from "./input.definitions";

export const DEFAULT_VALUES = {
  case: EKwikUIInputCase.DEFAULT,
  disabled: false,
  focus: false,
  formControlName: "form_control_input",
  hintContent: "",
  icon: "",
  id: "input",
  invalid: false,
  label: "Input",
  placeholder: "Please enter input",
  postfix: "",
  prefix: "",
  size: EKwikUIInputSize.L,
  type: EKwikUIInputType.TEXT
};

export const VALIDATE_KEY_VALUES = {
  case: true,
  disabled: true,
  focus: true,
  formControlName: true,
  hintContent: true,
  icon: true,
  id: true,
  invalid: true,
  label: true,
  placeholder: true,
  postfix: true,
  prefix: true,
  size: true,
  type: true
};
